import news from './dictionary/news';

const data = {
  council: {
    initial_tax: 0,
    value_tax: 7000000,
    max_tax: 100000000,
    council_1: false,
    council_1_val: 2000000,
    council_1_name: 'Fees, charges and other income',
    council_1_colour: '#A2D242',
    council_1_info: 'The council also charges for a range of services. You can only increase charges to recover the cost of delivering the service. Additional income could be generated by increasing fees and charges for services such as school meals, caretaking, registrars, bereavement services, planning and building control and providing advice and support to other organisations such as financial, legal, HR and audit.',
    council_2: false,
    council_2_val: 0,
    council_2_name: 'Parking',
    council_2_colour: '#2962B8',
    council_2_info: 'You can only increase charges across car parks to address traffic flows through and in the city.  We can review parking pricing and permits, including applying the same parking fees to Blue Badge holders in our car parks but always provide a free hour of parking at the end of their paid parking expiry time.',
    value_total: 0
  },
  spending_areas: [
    {
      sno: 1,
      name: 'Adult Social Care',
      description: 'Assistance for adults needing support to stay independent, safe and well.',
      max: 109000000,
      value: 109000000,
      step: 500000,
      color: '#369dea',
      icon: 'couple-icon.png',
      slug: 'adult_social_care',
      risk: {
        low: {
          from: 1,
          to: 9000000,
        },
        medium: {
          from: 9000001,
          to: 24000000,
        },
        high: {
          from: 24000001,
          to: 999999999999,
        }
      },
      info: 'Adult social care includes direct and commissioned services provided for adults with learning and physical disabilities and mental health needs and older people with care needs.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Building Based Care Services',
          gross_expenditure: '£7,610,980',
          gross_income: '(£3,798,350)',
          net_position: '£3,812,630'
        },
        {
          service_area: 'Business Continuity & Risk',
          gross_expenditure: '£189,290',
          gross_income: '(£72,420)',
          net_position: '£116,870'
        },
        {
          service_area: 'Care Services',
          gross_expenditure: '£1,633,270',
          gross_income: '(£240,600)',
          net_position: '£1,392,670'
        },
        {
          service_area: 'Supported Employment',
          gross_expenditure: '£717,890',
          gross_income: '(£717,890)',
          net_position: '-'
        },
        {
          service_area: 'Better Care Fund',
          gross_expenditure: '-',
          gross_income: '(£11,771,750)',
          net_position: '(£11,771,750)'
        },
        {
          service_area: 'Fairer Charging Income',
          gross_expenditure: '-',
          gross_income: '(£3,769,580)',
          net_position: '(£3,769,580)'
        },
        {
          service_area: 'Learning Disability',
          gross_expenditure: '£74,318,810',
          gross_income: '(£24,212,390)',
          net_position: '£50,106,420'
        },
        {
          service_area: 'Mental Health',
          gross_expenditure: '£15,843,990',
          gross_income: '(£6,816,550)',
          net_position: '£9,027,440'
        },
        {
          service_area: 'Older People',
          gross_expenditure: '£75,799,800',
          gross_income: '(£35,541,180)',
          net_position: '£40,258,620'
        },
        {
          service_area: 'Other Social Care Services',
          gross_expenditure: '£5,162,130',
          gross_income: '(£1,625,390)',
          net_position: '£3,536,740'
        },
        {
          service_area: 'Physical Disability',
          gross_expenditure: '£15,471,520',
          gross_income: '(£5,888,820)',
          net_position: '£9,582,700'
        },
        {
          service_area: 'Specialist Services Other',
          gross_expenditure: '£141,310',
          gross_income: '(£116,600)',
          net_position: '£24,710'
        },
        {
          service_area: 'Welfare Rights',
          gross_expenditure: '£931,790',
          gross_income: '(£563,270)',
          net_position: '£368,520'
        },
        {
          service_area: 'Prevention',
          gross_expenditure: '£690,280',
          gross_income: '(£383,270)',
          net_position: '£307,010'
        },
        {
          service_area: 'Reablement',
          gross_expenditure: '£6,610,650',
          gross_income: '(£4,051,020)',
          net_position: '£2,559,630'
        },
        {
          service_area: 'Commissioning',
          gross_expenditure: '£2,359,510',
          gross_income: '(£633,720)',
          net_position: '£1,725,790'
        },
        {
          service_area: 'Innovation',
          gross_expenditure: '-',
          gross_income: '-',
          net_position: '-'
        },
        {
          service_area: 'Other Services',
          gross_expenditure: '£114,950',
          gross_income: '-',
          net_position: '£114,950'
        },
        {
          service_area: 'People Finance',
          gross_expenditure: '£1,221,310',
          gross_income: '(£405,240)',
          net_position: '£816,070'
        },
        {
          service_area: 'Workforce Dev & Complaints',
          gross_expenditure: '£693,010',
          gross_income: '(£80,000)',
          net_position: '£613,010'
        }
        ]
      },
      triggers: [{
        from: 1,
        to: 9000000,
        consequences: [
          'We would need to support people differently, engaging more with neighbourhoods / communities so that those with low level needs can be supported by using alternatives to adult social care.',
          'Unplanned hospital admissions may increase, with longer lengths of stay - reducing the capacity of hospitals to deal with emergencies and other pressures.',
          'Increased pressure on primary care as people go to their GPs for support.',
          'There would be an increased dependency on people’s families/ local communities and neighbourhoods for support. People may need to use their own finances to purchase support independently.',
          'We would need to consider shared overnight support for people whose packages are complementary and a shared offer could meet their needs.',
          'Some services will need to close. Delays to hospital discharge. Reduced choice for people, example increase in residential care for people with expensive packages reduces independence and ability to live alone in the community',
        ],
        news: {
          id: 1,
          message: news['1'].text
        }
      },
      {
        from: 9000001,
        to: 24000000,
        consequences: [
          'There would be insufficient resources to keep up with demand for assessment and services. This would lead to longer waiting times, fewer people receiving care, people\'s needs escalating, and more unplanned hospital admissions and isolation. This would lead to increased risk of failure to meet our duty of care.',
          'More people may need to enter residential or nursing homes instead of being supported to remain at home, either because the costs of care at home are prohibitive or because their needs have escalated while they have been waiting for assessment/ a care package.',
          'A reduction in the workforce would have a detrimental impact on assessments and reviews as the priority focus would need to be on safeguarding and highly complex cases. Staff sickness absence and burnout would increase.',
          'Only basic support would be provided to carers which could increase the need for care packages, respite costs and residential care placements.',
          'We would face enforcement action, legal challenges and judicial review.',
        ],
        news: {
          id: 2,
          message: news['2'].text
        }
      },
      {
        from: 24000001,
        to: 999999999999,
        consequences: [
          'All but essential statutory services would cease.'
        ],
        news: {
          id: 3,
          message: news['3'].text
        }
      }
      ]
    }, {
      sno: 2,
      name: "Children's Social Care",
      description: 'Services focussed on the welfare and needs of children and families.',
      max: 53000000,
      value: 53000000,
      step: 500000,
      color: '#c96215',
      icon: 'hand-icon.png',
      slug: 'children_social_care',
      risk: {
        low: {
          from: 1,
          to: 3000000,
        },
        medium: {
          from: 3000001,
          to: 9000000,
        },
        high: {
          from: 9000001,
          to: 999999999999,
        }
      },
      info: "Children's social care includes looked after children, corporate parenting, social care services and children with special educational needs.",
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Children in Care',
          gross_expenditure: '£37,674,790',
          gross_income: '(£31,582,530)',
          net_position: '£36,092,260'
        },
        {
          service_area: 'Children With Disabilities',
          gross_expenditure: '£3,932,890',
          gross_income: '(£1,984,670)',
          net_position: '£1,948,220'
        },
        {
          service_area: 'Initial Contact, Referral and Assessment',
          gross_expenditure: '£3,380,070',
          gross_income: '-',
          net_position: '£3,380,070'
        },
        {
          service_area: 'Long Term Teams',
          gross_expenditure: '£4,441,360',
          gross_income: '-',
          net_position: '£4,441,360'
        },
        {
          service_area: 'Other Services',
          gross_expenditure: '£3,411,320',
          gross_income: '(£100,250)',
          net_position: '£3,311,070'
        },
        {
          service_area: 'Safeguarding Standards Unit',
          gross_expenditure: '£1,287,510',
          gross_income: '-',
          net_position: '£1,287,510'
        },
        {
          service_area: 'Specialist Services',
          gross_expenditure: '£1,735,170',
          gross_income: '-',
          net_position: '£1,735,170'
        },
        {
          service_area: 'Youth Justice Service',
          gross_expenditure: '£1,190,600',
          gross_income: '(£550,820)',
          net_position: '£639,780'
        }
        ],
      },
      triggers: [{
        from: 1,
        to: 3000000,
        consequences: [
          'There is a risk that there will not be sufficient Newcastle placements with the right skills and experience to care for children and young people with complex needs resulting from their adverse early childhood experiences.',
          'There is a risk that demand for service may increase, with more children coming into care and there would be fewer places available to keep them safe.'
        ],
        news: {
          id: 4,
          message: news['4'].text
        }
      },
      {
        from: 3000001,
        to: 9000000,
        consequences: [
          'If numbers of children coming into care do not reduce, there will be fewer places available to keep them safe.',
          'There will be less capacity  to support young people who have complex needs, leading to complications later in their lives.',
          'The service would be unable to make all home visits to children in need which would be unlawful.',
          'Overloaded case-workers and less management support will further compromise our ability to keep children safe.'
        ],
        news: {
          id: 5,
          message: news['5'].text
        }
      },
      {
        from: 9000001,
        to: 999999999999,
        consequences: [
          'This would mean we could not remove children from risky home situations.',
          'It would mean an increase in caseloads for social workers and less management support leading to potentially dangerous decisions.',
          'It may also mean that social workers would not be able to intervene in family situations to prevent issues becoming more serious.',
          'We would not be able to visit children in need, which would be unlawful under the Children Act.',
          'There would be a high likelihood that children would suffer life threatening and life changing abuse.',
          'It would lead to extreme need in schools and overwhelm ability to find alternative placements for vulnerable young people, increasing those who are NEET reducing their chances long term.',
          'Statutory responsibilities impacted upon.'
        ],
        news: {
          id: 6,
          message: news['6'].text
        }
      },
      ]
    }, {
      sno: 3,
      name: 'Refuse, Waste Collection and Disposal',
      description: 'Collecting and disposing of household and commercial waste and recycling.',
      max: 20000000,
      value: 20000000,
      step: 500000,
      color: '#0063be',
      icon: 'bin-icon.png',
      slug: 'refuse_waste_collection_disposal',
      risk: {
        low: {
          from: 1,
          to: 1000000,
        },
        medium: {
          from: 1000001,
          to: 2500000,
        },
        high: {
          from: 2500001,
          to: 999999999999,
        }
      },
      info: 'Refuse, waste collection and disposal includes refuse and recycling collections and the disposal of waste.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Blue Bin Collection',
          gross_expenditure: '£2,313,940',
          gross_income: '(£20,000)',
          net_position: '£2,293,940'
        },
        {
          service_area: 'Bulky Waste Collection',
          gross_expenditure: '£86,210',
          gross_income: '(£143,760)',
          net_position: '(£57,550)'
        },
        {
          service_area: 'Clinical Waste',
          gross_expenditure: '£95,520',
          gross_income: '(£95,520)',
          net_position: '-'
        },
        {
          service_area: 'Composting',
          gross_expenditure: '£345,750',
          gross_income: '(£49,570)',
          net_position: '£296,180'
        },
        {
          service_area: 'Domestic Refuse Collection',
          gross_expenditure: '£2,475,660',
          gross_income: '(£38,930)',
          net_position: '£2,436,730'
        },
        {
          service_area: 'Garden Waste Collection',
          gross_expenditure: '£455,330',
          gross_income: '(£958,260)',
          net_position: '(£502,930)'
        },
        {
          service_area: 'Trade Waste',
          gross_expenditure: '£2,844,830',
          gross_income: '(£3,083,420)',
          net_position: '(£238,590)'
        },
        {
          service_area: 'Waste Disposal Contracts',
          gross_expenditure: '£13,366,520',
          gross_income: '(£382,540)',
          net_position: '£12,983,980'
        },
        {
          service_area: 'Waste Management',
          gross_expenditure: '£2,344,740',
          gross_income: '(£29,300)',
          net_position: '£2,315,440'
        }
        ],
      },
      triggers: [{
        from: 1,
        to: 1000000,
        consequences: [
          'Fortnightly collections may not be maintained, and there will be a reduced ability to catch up if service interruptions occur, for instance as a result of extreme weather or vehicle breakdown.',
          'We will need to apply above inflation prices increases for all paid-for services such as garden waste, bulky waste and trade waste.',
          'We will continue to work with our waste disposal contractor to minimise our waste disposal costs.'
        ],
        news: {
          id: 7,
          message: news['7'].text
        }
      },
      {
        from: 1000001,
        to: 2500000,
        consequences: [
          'We will need to move residual waste collection (Green Bins) and recycling (Blue Bin) to a three-weekly collection, which will result in job losses.',
          'We will face increased waste disposal costs if fly-tipping increases as a result of the changes.',
          'We will increase prices even more for our paid for services.',
          'We will reduce the number of Household Waste Recycling Centres, but still provide a much-reduced service, or reduced opening hours.'
        ],
        news: {
          id: 8,
          message: news['8'].text
        }
      },
      {
        from: 2500001,
        to: 999999999999,
        consequences: [
          'We will apply significant price increases to paid-for services which may make them uncompetitive and result in the withdrawal of the service.',
          'We may need to move residual waste collection to once a month.',
          'We would operate just one Household Waste Recycling Centre on reduced opening hours, to comply with our statutory duties.'
        ],
        news: {
          id: 9,
          message: news['9'].text
        }
      },
      ]
    }, {
      sno: 4,
      name: 'Early Years and Education',
      description: 'Providing education, learning and care to children, young people and families.',
      max: 13000000,
      value: 13000000,
      step: 500000,
      color: '#039bad',
      icon: 'education-icon.png',
      slug: 'education_early_years',
      risk: {
        low: {
          from: 1,
          to: 2000000,
        },
        medium: {
          from: 2000001,
          to: 6000000,
        },
        high: {
          from: 6000001,
          to: 999999999999,
        }
      },
      info: 'Early years and education includes family services, home to school transport and the PFI costs associated with the school buildings. The spend on individual schools is excluded as this is funded separately by dedicated schools grant.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [
          {
            service_area: 'Family Services',
            gross_expenditure: '£9,101,230',
            gross_income: '(£6,094,290)',
            net_position: '£3,006,940'
          },
          {
            service_area: 'Strategy & Commissioning Unit',
            gross_expenditure: '£1,374,660',
            gross_income: '(£150,000)',
            net_position: '(£1,224,660)'
          },
          {
            service_area: 'Education Management',
            gross_expenditure: '£831,200',
            gross_income: '(£5,267,630)',
            net_position: '(£4,436,430)'
          },
          {
            service_area: 'Financial Services to Schools',
            gross_expenditure: '£348,740',
            gross_income: '(£297,470)',
            net_position: '£51,270'
          },
          {
            service_area: 'Music Service',
            gross_expenditure: '£595,180',
            gross_income: '(£595,180)',
            net_position: '-'
          },
          {
            service_area: 'PFI and BSF',
            gross_expenditure: '£35,615,380',
            gross_income: '(£34,318,890)',
            net_position: '£1,296,490'
          },
          {
            service_area: 'School Effectiveness',
            gross_expenditure: '£1,967,710',
            gross_income: '(£1,356,450)',
            net_position: '£611,260'
          },
          {
            service_area: 'School Org & Infrastructure',
            gross_expenditure: '£1,004,820',
            gross_income: '(£723,920)',
            net_position: '£280,900'
          },
          {
            service_area: 'SEN',
            gross_expenditure: '£3,105,720',
            gross_income: '(£1,185,790)',
            net_position: '£1,919,930'
          },
          {
            service_area: 'SEN Transport',
            gross_expenditure: '£8,995,490',
            gross_income: '(£183,240)',
            net_position: '£8,812,250'
          },
          {
            service_area: 'Virtual School',
            gross_expenditure: '£1,503,180',
            gross_income: '(£1,487,160)',
            net_position: '£16,020'
          },
        ],
      },
      triggers: [{
        from: 1,
        to: 2000000,
        consequences: [
          'We would no longer be able to provide supported childcare places for our most vulnerable children in the city, including those in our care.',
          'We would need to close at least one of the council run nurseries within the city.',
          'More families struggle therefore greater pressure on other social care services and health services.',
          'If we were to reduce Education budgets to this extent there would be a risk that the council would not be able to deliver on its statutory functions such as Special Educational Needs and Disabilities (SEND) and School admissions.',
          'The less early childcare we have for most vulnerable the greater the need when they come into education and this puts a strain on our schools and our special needs service.',
          'Impact upon the sufficiency of childcare in the city.'
        ],
        news: {
          id: 10,
          message: news['10'].text
        }
      },
      {
        from: 2000001,
        to: 6000000,
        consequences: [
          'We would stop providing some of our intensive family support services.',
          'This would significantly increase the likelihood of the council being unable to meet legal and statutory duties resulting in legal challenge especially around admissions, Special Educational Needs and Disabilties and school transport.',
          'Working parents are impacted upon.',
          'Impact on school staff dealing with children who are not ready for school.'
        ],
        news: {
          id: 11,
          message: news['11'].text
        }
      },
      {
        from: 6000001,
        to: 999999999999,
        consequences: [
          'We would stop providing more of our intensive family support services.',
          'There would be no family support services for anyone in the city. Families are struggling and will start to hit crisis point.',
          'Fewer children are "school ready" when they start school therefore the attainment of pupils across the city is affected.',
          'This would lead to more children being vulnerable and needing social care and specialist education services in the future.',
          'We would have to stop providing some of our statutory education services such as admissions, Special Educational Needs support, pupil place planning and School transport facing enforcement action, legal challenge or judicial review.',
          'Increase in young people who are NEET and increased likelihood of engaging in crime.',
          'Reduced support for inclusion in mainstream schools - overwhelming alternative provision due to increase in exclusions.'
        ],
        news: {
          id: 12,
          message: news['12'].text
        }
      },
      ]
    }, {
      sno: 5,
      name: 'Culture, Leisure and Libraries',
      description: 'Offering cultural activities, recreational facilities, and library services.',
      max: 6000000,
      value: 6000000,
      step: 500000,
      color: '#c5019f',
      icon: 'culture-icon.png',
      slug: 'culture_leisure_libraries',
      risk: {
        low: {
          from: 1,
          to: 1000000,
        },
        medium: {
          from: 1000001,
          to: 3000000,
        },
        high: {
          from: 3000001,
          to: 999999999999,
        }
      },
      info: 'Culture, leisure and libraries includes customer contact, libraries, museums arts and culture, leisure services and parks.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Arts and Culture',
          gross_expenditure: '£971,540',
          gross_income: '(£200,000)',
          net_position: '£771,540'
        },
        {
          service_area: 'Museums and Archives',
          gross_expenditure: '£883,310',
          gross_income: '-',
          net_position: '£883,310'
        },
        {
          service_area: "Children's Rights Team",
          gross_expenditure: '-',
          gross_income: '-',
          net_position: '-'
        },
        {
          service_area: 'City Hall',
          gross_expenditure: '(£110)',
          gross_income: '-',
          net_position: '(£110)'
        },
        {
          service_area: 'Community Buildings',
          gross_expenditure: '£76,720',
          gross_income: '(£2,500)',
          net_position: '£74,220'
        },
        {
          service_area: 'Communities Team',
          gross_expenditure: '£628,620',
          gross_income: '(£370,900)',
          net_position: '£257,720'
        },
        {
          service_area: 'Customer Contact and Libraries',
          gross_expenditure: '£11,218,950',
          gross_income: '(£6,564,160)',
          net_position: '£4,654,790'
        },
        {
          service_area: 'Digital Projects',
          gross_expenditure: '(£103,430)',
          gross_income: '-',
          net_position: '(£103,430)'
        },
        {
          service_area: 'Events (Christmas)',
          gross_expenditure: '£120,870',
          gross_income: '£173,360',
          net_position: '£52,490'
        },
        {
          service_area: 'Open Spaces',
          gross_expenditure: '£316,530',
          gross_income: '(£1,218,370)',
          net_position: '(£901,840)'
        },
        {
          service_area: 'Leisure',
          gross_expenditure: '£1,801,150',
          gross_income: '(£1,801,150)',
          net_position: '-'
        },
        {
          service_area: 'Ward Budgets',
          gross_expenditure: '£237,730',
          gross_income: '(£33,710)',
          net_position: '£204,020'
        }
        ],
      },
      triggers: [{
        from: 1,
        to: 1000000,
        consequences: [
          'No libraries will close but some may be open for fewer days per week, or for fewer hours per day, including the City Library.',
          'We may review the Library spaces in multi-use buildings as we try to reduce the total space occupied by the council across the city.',
          'Our staff will work more closely with partner organisations in the buildings where there is a multi agency arrangement.',
          'We will reduce our contribution to Tyne and Wear Archives and Museums who manage the Laing Art Gallery and Discovery Museum on our behalf.'
        ],
        news: {
          id: 13,
          message: news['13'].text
        }
      },
      {
        from: 1000001,
        to: 3000000,
        consequences: [
          'The library estate is likely to reduce to the City Library and two or three other locations.',
          'The book and media purchase budget will be reduced significantly.',
          'We will engage with partners and volunteer groups to run the remaining branch libraries to try and maintain those locations, otherwise those libraries will close.',
          'Small scale arts and culture projects would stop.',
          'Customers calling our contact centre will experience shorter opening hours and longer waiting times.'
        ],
        news: {
          id: 14,
          message: news['14'].text
        }
      },
      {
        from: 3000001,
        to: 999999999999,
        consequences: [
          'The library service will be reduced to City Library only and opening hours will be limited, at risk of meeting our statutory duty to comprehensive and efficient library service.',
          'There would be a reduction in the number of ways members of the public could access council services.',
          'The Discovery Museum and Laing Art Gallery and the archives service may be at risk of closure, potentially breaching our statutory duties to maintain public records.',
          'We will have no funding to promote active lifestyles and leisure activity.'
        ],
        news: {
          id: 15,
          message: news['15'].text
        }
      },
      ]
    }, {
      sno: 6,
      name: 'Maintaining Highways',
      description: 'Keeping roads safe, well-maintained, and managing parking areas.',
      max: 13000000,
      value: 13000000,
      step: 500000,
      color: '#009dda',
      icon: 'highway-icon.png',
      slug: 'maintaining_highways_parking',
      risk: {
        low: {
          from: 1,
          to: 1000000,
        },
        medium: {
          from: 1000001,
          to: 3000000,
        },
        high: {
          from: 3000001,
          to: 999999999999,
        }
      },
      info: 'Maintaining highways the maintenance of the highways network and costs of street lighting.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Network Management & Construction',
          gross_expenditure: '£1,335,080',
          gross_income: '(£1,016,210)',
          net_position: '£318,870'
        },
        {
          service_area: 'Engineering Consultancy Services',
          gross_expenditure: '£17,642,440',
          gross_income: '(£5,024,830)',
          net_position: '£12,617,610'
        },
        {
          service_area: 'Transport Development and Strategy',
          gross_expenditure: '£1,452,070',
          gross_income: '(£1,419,180)',
          net_position: '£32,890'
        }
        ],
      },
      triggers: [{
        from: 1,
        to: 1000000,
        consequences: [
          'There will be a significant risk of flooding.',
          'We will fill fewer potholes and our capability to carry out all other repairs to roads and pavements will be reduced.',
          'There will be a higher risk of liability claims against us which means we would need to pay out more money which would have been spent on delivering other services.',
          'There will be a reduction in the number of roads we are able to grit.'
        ],
        news: {
          id: 16,
          message: news['16'].text
        }
      },
      {
        from: 1000001,
        to: 999999999999,
        consequences: [
          'We will not be able to carry out maintenance work on bridges.',
          'There will be more road closures.',
          'We may consider reducing street lighting in residential areas between midnight and 6am.',
          'It would be difficult for us to manage the impact and effect of other contractors working on our highways.',
          'Gullies may be blocked increasing the risk of flooding.'
        ],
        news: {
          id: 17,
          message: news['17'].text
        }
      },
      ]
    }, {
      sno: 7,
      name: 'Maintaining Neighbourhoods',
      description: 'Cleaning streets, removing litter, graffiti, and fly-tipping to upkeep local areas.',
      max: 10000000,
      value: 10000000,
      step: 500000,
      color: '#9c2b98',
      icon: 'neighbourhood-icon.png',
      slug: 'maintaining_neighbourhoods',
      risk: {
        low: {
          from: 1,
          to: 1000000,
        },
        medium: {
          from: 1000001,
          to: 2500000,
        },
        high: {
          from: 2500001,
          to: 999999999999,
        }
      },
      info: 'Maintaining neighbourhoods includes street cleansing services, including road and pavement cleansing, litter removal, removal of fly-tipping and graffiti.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Arbor',
          gross_expenditure: '£983,400',
          gross_income: '(£688,530)',
          net_position: '£294,870'
        },
        {
          service_area: 'Behavioural Change',
          gross_expenditure: '£290,970',
          gross_income: '(£244,000)',
          net_position: '£46,970'
        },
        {
          service_area: 'Depots & Estate Management',
          gross_expenditure: '£2,180,470',
          gross_income: '(£275,300)',
          net_position: '£1,905,170'
        },
        {
          service_area: 'Grounds',
          gross_expenditure: '£3,451,100',
          gross_income: '(£2,673,660)',
          net_position: '£777,440'
        },
        {
          service_area: 'Pest Control',
          gross_expenditure: '£193,020',
          gross_income: '(£379,020)',
          net_position: '(£186,000)'
        },
        {
          service_area: 'Street Services Management',
          gross_expenditure: '£966,180',
          gross_income: '-',
          net_position: '£966,180'
        },
        {
          service_area: 'Street Wardens',
          gross_expenditure: '£359,150',
          gross_income: '(£336,810)',
          net_position: '£22,340'
        },
        {
          service_area: 'Ward Based Services',
          gross_expenditure: '£6,610,270',
          gross_income: '(£601,570)',
          net_position: '£6,008,700'
        }
        ],
      },
      triggers: [{
        from: 1,
        to: 1000000,
        consequences: [
          'City centre and city wide streets will be swept less often, resulting in an increased build up of litter and rubbish.',
          'Cleansing standards can only be maintained if the majority of citizens who drop litter change their behaviour.',
          'Grounds maintenance will be reduced, resulting in reduced grass cutting frequencies and less shrub maintenance.',
          'It\'s likely there will be an increase in complaints and resident dissatisfaction.',
          'We will have less capacity to respond to fly-tipping.'
        ],
        news: {
          id: 18,
          message: news['18'].text
        }
      },
      {
        from: 1000001,
        to: 2500000,
        consequences: [
          'There would be a further reduction in scheduled sweeping. We may need to consider ending scheduled sweeping on some residential streets and back-lanes, which would also result in job losses.',
          'City centre cleansing would be reduced, resulting in a dirtier environment, unless people stop dropping litter.',
          'We will only provide a response service to the most severe of littering problems.',
          'Grass would be cut less often.',
          'It\'s likely that there will be an increase in rubbish, plus weed growth resulting in expensive pavement damage.',
          'There\'s a risk that we may be unable to comply with public health and environmental legislation.',
          'All environmental campaigns to reduce, reuse and recycle, will stop.'
        ],
        news: {
          id: 19,
          message: news['19'].text
        }
      },
      {
        from: 2500001,
        to: 999999999999,
        consequences: [
          'The City Centre becomes less attractive to businesses, residents and visitors.',
          'Some key businesses may consider leaving the city.',
          'Grass may only get cut once or twice a year.  Shrub and flower beds would not be maintained.',
          'It is likely that we would not comply with the Environmental Protection Act.',
          'Reduced spend on depots results in an increase in vandalism and theft of vehicles and equipment.',
          'There would be no scheduled sweeping within residential streets and back-lanes, which would also result in job losses.'
        ],
        news: {
          id: 20,
          message: news['20'].text
        }
      }
      ]
    }, {
      sno: 8,
      name: 'Planning and Development',
      description: 'Determining planning application, preparing planning policy, and enforcing development.',
      max: 1000000,
      value: 1000000,
      step: 500000,
      color: '#4d4e53',
      icon: 'planning-icon.png',
      slug: 'planning_and_development',
      risk: {
        low: {
          from: 1,
          to: 500000,
        },
        medium: {
          from: 500001,
          to: 1500000,
        },
        high: {
          from: 1500001,
          to: 999999999999,
        }
      },
      info: 'Planning and development includes planning applications, enforcement of building and planning regulations and housing.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Building Control',
          gross_expenditure: '£658,310',
          gross_income: '(£874,070)',
          net_position: '(£215,760)'
        },
        {
          service_area: 'Development Management',
          gross_expenditure: '£2,541,960',
          gross_income: '(£2,181,060)',
          net_position: '£360,900'
        },
        {
          service_area: 'Energy',
          gross_expenditure: '£739,360',
          gross_income: '(£570,820)',
          net_position: '£168,540'
        },
        {
          service_area: 'Housing and Planning Strategy',
          gross_expenditure: '£251,770',
          gross_income: '-',
          net_position: '£251,770'
        },
        {
          service_area: 'Housing Development and Partnership',
          gross_expenditure: '£1,582,400',
          gross_income: '(£1,665,740)',
          net_position: '(£83,340)'
        },
        {
          service_area: 'Local Development Framework',
          gross_expenditure: '£129,890',
          gross_income: '-',
          net_position: '£129,890'
        }
        ],
      },
      triggers: [{
        from: 1,
        to: 500000,
        consequences: [
          'There may be a reduction in local consultation, limiting the opportunity for people to have their say on new developments.',
          'There may be delays in granting planning applications which may in turn delay development of housing across the city.',
          'There may be delays to the determination of householder applications.',
          'There may also be delays in assessing planning applications for business related development which may impact on economic development and employment.'
        ],
        news: {
          id: 21,
          message: news['21'].text
        }
      },
      {
        from: 500001,
        to: 999999999999,
        consequences: [
          'Fewer homes would be built each year including fewer affordable homes.',
          'We would be unable to deliver the number of extra care housing schemes that are needed.',
          'Moving forwards, there may be less commercial development across the city and so fewer jobs created.',
          'We would continue to meet our statutory duty in relation to maintaining building safety, but may not be able to provide other building control services.',
          'We may not be able to effectively manage energy contracts, resulting in increased energy costs in our buildings.',
          'Reduction in planning enforcement service increasing the risk of detrimental development.'
        ],
        news: {
          id: 22,
          message: news['22'].text
        }
      }
      ]
    }, {
      sno: 9,
      name: 'Public Health and Housing',
      description: 'Enhancing community health, wellness, and reducing health disparities.',
      max: 0,
      value: 0,
      step: 500000,
      color: '#d80073',
      locked: true,
      icon: 'public-health-icon.png',
      slug: 'public_health',
      info: 'We are responsible for improving wellbeing and health and reducing health inequalities in our city. This budget is ring-fenced and cannot be reduced.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Public Health and Housing',
          gross_expenditure: '£18,703,810',
          gross_income: '(£19,707,970)',
          net_position: '(£1,004,160)'
        },],
      },
      triggers: [{
        from: 1,
        to: 999999999999,
        consequences: [],
        news: ''
      }]
    }, {
      sno: 10,
      name: 'Business and Economic Development',
      description: 'Promoting business growth and overseeing major projects.',
      max: 1000000,
      value: 1000000,
      step: 500000,
      color: '#009ddb',
      icon: 'business-icon.png',
      slug: 'business_econ_development',
      risk: {
        low: {
          from: 1,
          to: 500000,
        },
        medium: {
          from: 500001,
          to: 1500000,
        },
        high: {
          from: 1500001,
          to: 999999999999,
        }
      },
      info: 'Business and economic development includes economic development and major capital projects and programmes.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Corporate Economic Development',
          gross_expenditure: '£838,600',
          gross_income: '(£338,240)',
          net_position: '£500,360'
        },
        {
          service_area: 'Grant Funded Programmes',
          gross_expenditure: '-',
          gross_income: '-',
          net_position: '-'
        },
        {
          service_area: 'Major Projects',
          gross_expenditure: '£966,170',
          gross_income: '(£999,450)',
          net_position: '(£33,280)'
        },
        {
          service_area: 'Projects',
          gross_expenditure: '£608,430',
          gross_income: '(£267,400)',
          net_position: '£341,030'
        }
        ],
      },
      triggers: [{
        from: 1,
        to: 500000,
        consequences: [
          'There will be a reduction in activity that attracts inward investment to the city. This would have an negative impact on business and employment.',
          'There would also a reduction in our ability to attract and secure grants that support business innovation, employment and carbon reduction.',
          'Reduction in our ability to deliver capital investment and projects, which are crucial to developing the city and improving council services.'
        ],
        news: {
          id: 23,
          message: news['23'].text
        }
      },
      {
        from: 500001,
        to: 999999999999,
        consequences: [
          'Full removal of the function would severely impact the level of resource available to invest in infrastructure, education, energy efficiency and new employment opportunities.',
          'This would result in a decline of the local transport networks and commercial and retail facilities.'
        ],
        news: {
          id: 24,
          message: news['24'].text
        }
      },
      ]
    }, {
      sno: 11,
      name: 'Enforcement and Regulation',
      description: 'Enforcing environmental standards, trading rules, and safety regulations.',
      max: 1000000,
      value: 1000000,
      step: 500000,
      color: '#9b2c98',
      icon: 'enforcement-icon.png',
      slug: 'enforcement_and_regulation',
      risk: {
        low: {
          from: 1,
          to: 500000,
        },
        medium: {
          from: 500001,
          to: 1500000,
        },
        high: {
          from: 1500001,
          to: 999999999999,
        }
      },
      info: 'Enforcement and regulation includes environmental protection and public protection, trading standards, licensing, resilience planning and Safe Newcastle.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Food Safety Planning & Events',
          gross_expenditure: '£587,240',
          gross_income: '(£137,430)',
          net_position: '£449,810'
        },
        {
          service_area: 'Environmental Protection',
          gross_expenditure: '£608,620',
          gross_income: '(£341,630)',
          net_position: '£266,990'
        },
        {
          service_area: 'Licensing',
          gross_expenditure: '£3,015,720',
          gross_income: '(£3,657,210)',
          net_position: '(£641,490)'
        },
        {
          service_area: 'Public Protection and Neighbourhoods',
          gross_expenditure: '£206,600',
          gross_income: '-',
          net_position: '£206,600'
        },
        {
          service_area: 'Trading Standards',
          gross_expenditure: '£173,170',
          gross_income: '(£4,000)',
          net_position: '£169,170'
        },
        {
          service_area: 'Resilience Planning',
          gross_expenditure: '£201,150',
          gross_income: '(£33,220)',
          net_position: '£167,930'
        },
        {
          service_area: 'Safe Newcastle',
          gross_expenditure: '£569,450',
          gross_income: '(£208,760)',
          net_position: '£360,690'
        },
        ],
      },
      triggers: [{
        from: 1,
        to: 500000,
        consequences: [
          'We would need to scale back essential services to monitor food safety, trading standards, noise and air quality and tackling rogue landlords and dealing with issues such as damp and mould, which would create a public health issue particularly for those who are most vulnerable and at risk in our City.',
          'We would need to reduce support to tackle anti-social behaviour.'
        ],
        news: {
          id: 25,
          message: news['25'].text
        }
      },
      {
        from: 500001,
        to: 999999999999,
        consequences: [
          'Food safety inspections, trading standard activity, health and safety inspections, noise monitoring, air quality monitoring and Tyne River maintenance would reduce, having a negative impact on the public\'s health and potentially would result in government intervention.',
          'Our ability to respond to serious outbreaks of infectious diseases and life threatening allergen incidents would be significantly reduced.',
          'There would be fewer enforcement officers to prosecute those who drop litter and fly-tip.',
          'There would be reduced capacity to tackle crime and anti-social behaviour and we would potentially fail in our legal duty to deal with nuisance issues and expose vulnerable vicitms to unnecessary harm.',
          'Failure to deal with housing disrepair and nuisance issues would result in legal action against the local authority for failure to carry out legal responsibilites to ensure healthy and safe housing.',
          'Possible exploitation of vulnerable people due to lack of regulation.'
        ],
        news: {
          id: 26,
          message: news['26'].text
        }
      },
      ]
    }, {
      sno: 12,
      name: 'Enabling and Business Functions',
      description: 'Providing central support services including legal, ICT, financial services, human resources.',
      max: 9000000,
      value: 9000000,
      step: 500000,
      color: '#ffa200',
      icon: 'support-icon.png',
      slug: 'core_business_functions',
      risk: {
        low: {
          from: 1,
          to: 3000000,
        },
        medium: {
          from: 3000001,
          to: 6000000,
        },
        high: {
          from: 6000001,
          to: 999999999999,
        }
      },
      info: 'Central and support services include Legal,  ICT, Human Resources, Financial Services, Democratic Services, Policy, Communications and Performance and a range of cross-organisation traded and income generating services.',
      table: {
        headings: [{
          label: 'Service Area',
          slug: 'service_area',
        },
        {
          label: 'Gross Expenditure',
          slug: 'gross_expenditure',
        },
        {
          label: 'Gross Income',
          slug: 'gross_income',
        },
        {
          label: 'Net Position',
          slug: 'net_position',
        }
        ],
        rows: [{
          service_area: 'Audit, Risk and Insurance',
          gross_expenditure: '£941,350',
          gross_income: '(£386,260)',
          net_position: '£555,090'
        },
        {
          service_area: 'Financial Services',
          gross_expenditure: '£2,842,440',
          gross_income: '(£544,420)',
          net_position: '£2,298,020'
        },
        {
          service_area: 'Revenues and Benefits',
          gross_expenditure: '£5,343,780',
          gross_income: '(£3,257,390)',
          net_position: '£2,086,390'
        },
        {
          service_area: 'Business Management including Administration',
          gross_expenditure: '£8,141,240',
          gross_income: '(£1,018,290)',
          net_position: '£7,122,950'
        },
        {
          service_area: 'Commissioning and Procurement',
          gross_expenditure: '£1,218,840',
          gross_income: '(£1,347,500)',
          net_position: '(£128,660)'
        },
        {
          service_area: 'Legal Services and Coroner',
          gross_expenditure: '£3,505,370',
          gross_income: '(£1,279,910)',
          net_position: '£2,225,460'
        },
        {
          service_area: 'Democratic and Electoral Services',
          gross_expenditure: '£2,274,390',
          gross_income: '(£106,550)',
          net_position: '£2,167,840'
        },
        {
          service_area: 'Human Resources, Training and Health and Safety',
          gross_expenditure: '£3,084,380',
          gross_income: '(£1,173,570)',
          net_position: '£1,910,810'
        },
        {
          service_area: 'ICT Operations and Equipment',
          gross_expenditure: '£11,186,420',
          gross_income: '(£4,730,230)',
          net_position: '£6,456,190'
        },
        {
          service_area: 'Policy, Performance and Communications',
          gross_expenditure: '£2,777,210',
          gross_income: '(£959,210)',
          net_position: '£1,818,000'
        },
        {
          service_area: 'Property Services',
          gross_expenditure: '£1,852,960',
          gross_income: '(£1,499,490)',
          net_position: '£353,470'
        },
        {
          service_area: 'IE Projects',
          gross_expenditure: '',
          gross_income: '',
          net_position: '-'
        },
        {
          service_area: 'Inclusive Employment Core',
          gross_expenditure: '',
          gross_income: '',
          net_position: '-'
        },
        {
          service_area: 'Security Services',
          gross_expenditure: '£714,320',
          gross_income: '(£741,440)',
          net_position: '(£27,120)'
        },
        {
          service_area: 'Chief Executive and Directors',
          gross_expenditure: '£1,383,650',
          gross_income: '(£190,990)',
          net_position: '£1,192,660'
        },
        {
          service_area: 'Highways Maintenance and Operations',
          gross_expenditure: '£13,382,760',
          gross_income: '(£14,231,040)',
          net_position: '(£848,280)'
        },
        {
          service_area: 'City Build Overheads',
          gross_expenditure: '£2,579,780',
          gross_income: '(£257,570)',
          net_position: '£2,322,210'
        },
        {
          service_area: 'Stores and Business Development',
          gross_expenditure: '-',
          gross_income: '-',
          net_position: '-'
        },
        {
          service_area: 'Architecture, Mechanical and Energy Team',
          gross_expenditure: '£4,958,130',
          gross_income: '(£5,547,960)',
          net_position: '(£589,830)'
        },
        {
          service_area: 'Design and Construction Services',
          gross_expenditure: '£39,014,890',
          gross_income: '(£45,347,810)',
          net_position: '(£6,332,920)'
        },
        {
          service_area: 'City Transport',
          gross_expenditure: '£7,280,840',
          gross_income: '(£9,178,700)',
          net_position: '(£1,897,860)'
        },
        {
          service_area: 'Highway Consultancy etc',
          gross_expenditure: '£1,020,830',
          gross_income: '(£1,238,020)',
          net_position: '(£217,190)'
        },
        {
          service_area: 'Civic Facilities',
          gross_expenditure: '£5,852,570',
          gross_income: '(£5,667,710)',
          net_position: '£184,860'
        },
        {
          service_area: 'Caretaking',
          gross_expenditure: '£1,757,810',
          gross_income: '(£1,600,270)',
          net_position: '£157,540'
        },
        {
          service_area: 'Building Cleaning',
          gross_expenditure: '£8,968,960',
          gross_income: '(£7,626,520)',
          net_position: '£1,342,440'
        },
        {
          service_area: 'Catering and School Meals',
          gross_expenditure: '£11,482,440',
          gross_income: '(£11,480,440)',
          net_position: '£2,000'
        },
        {
          service_area: 'Parking',
          gross_expenditure: '£7,701,790',
          gross_income: '(£20,955,080)',
          net_position: '(£13,253,290)'
        },
        ],
      },
      triggers: [{
        from: 1,
        to: 3000000,
        consequences: [
          'Day-to-day business functions would be hampered, resulting in slower and less responsive front-line services.',
          'We would have reduced capacity for public information such as the residents\' magazine and maintenance of the website.'
        ],
        news: {
          id: 27,
          message: news['27'].text
        }
      },
      {
        from: 3000001,
        to: 6000000,
        consequences: [
          'Our ability to deliver traded services will reduce, resulting in loss of income to the council.',
          'Reductions in core functions, for instance Project Management, Commissioning and Procurement, Finance and Legal Services would compromise our ability to make future savings.',
          'We would lose income through reduced capacity to collect Council Tax.',
          'Response and processing times for benefits claims will be slower, leading to increased risk of hardship.'
        ],
        news: {
          id: 28,
          message: news['28'].text
        }
      },
      {
        from: 6000001,
        to: 999999999999,
        consequences: [
          'Our ability to ensure effective governance and decision-making will be compromised increasing the risk of costs incurred through legal challenges claims.',
          'The Electoral Register could not be managed effectively, meaning that people may not be able to vote and fail to our meet to our statutory duties.',
          'Our computer systems will not be adequately maintained, resulting in disruption to customers and front line services.',
          'We may stop monitoring CCTV cameras in the city centre and wards, which will reduce our ability to intervene in crime and community safety issues.',
          'Major incidents in the city would be responded to in a less coordinated manner owing to the lower number of appropriately trained and skilled managers and staff in the organisation.',
          'School Meals Service may become unviable resulting in unsufficient provision to schools.',
          'Unable to maintain crematorium and cemeteries to the right standard and provide high quality service, and reduced service to the bereaved.'
        ],
        news: {
          id: 29,
          message: news['29'].text
        }
      },
      ]
    },],
}

export default data;


// WEBPACK FOOTER //
// ./src/data.js